




















import { Component, Vue } from "vue-property-decorator";
import { postLoggedOut } from "../api";
import Card from "./Card.vue";
import { namespace, Mutation } from "vuex-class";

const authStore = namespace("auth");

@Component({
  components: { Card },
})
export default class LogoutCard extends Vue {
  @authStore.Action setLoggedIn!: (state: boolean) => Promise<void>;
  @Mutation loadInitialState!: () => void;

  pending = true;
  success = false;

  async processToken(): Promise<void> {
    try {
      await postLoggedOut();
      this.success = true;
    } catch (e) {
      this.success = false;
    }
    this.setLoggedIn(false);
    this.pending = false;
    this.loadInitialState();
    this.$router.replace({ name: "logout", query: { logged_out: "true" } });
  }

  mounted(): void {
    if (this.$route.query.logged_out === "true") {
      this.$router.push({ name: "home" });
    } else {
      this.processToken();
    }
  }
}
